<template>
  <div class="content">
    <div class="header d-flex justify-content-between align-items-center">
      <div class="title ml-3">
        <h3 class="h3 mb-n2 bold">Cálculo do Incremento de Pesquisadores</h3>
        <span class="h6 mt-n2 text-gray-400">
          Cálculo de incremento de pesquisadores em percentual
        </span>
      </div>
      <div class="actions d-flex align-items-center">
        <div class="d-flex align-items-center">
          <div class="d-flex">
            <v-select
              style="max-width: 170px"
              class="mb-n2 mr-5"
              prepend-icon="mdi-calendar"
              prefix="Ano-base"
              :items="anosBase"
              v-model="anoBase"
              dense
              @change="doLoad"
            ></v-select>
          </div>
          <v-menu offset-y left v-if="!isCliente">
            <template v-slot:activator="{ on, attrs }">
              <button
                class="btn btn-secondary text-white elevation-3"
                data-testid="incremento-pesquisador-exportacoes"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left class="text-white">mdi-cloud-download-outline</v-icon>
                Exportações
                <v-icon right class="text-white">mdi-chevron-down</v-icon>
              </button>
            </template>
            <v-list dense>
              <v-list-item
                data-testid="incremento-pesquisador-exportar-pdf"
                @click="doAsyncExport('incremento-pesquisadores')"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon color="error">mdi-file-pdf-box</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Exportação assíncrona PDF</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                data-testid="incremento-pesquisador-exportar-xlsx"
                @click="doAsyncExport('incremento-pesquisadores-excel')"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon color="success">mdi-file-excel-box</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Exportação assíncrona XLSX</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="teros-elevation rounded" :color="tableColor">
        <v-data-table
          class="mb-7 mt-2"
          data-app
          :headers="headerStyle(colunas.detalhes)"
          :items="detalhes"
          :footer-props="{
            'items-per-page-options': [-1],
          }"
          hide-default-footer
        >
          <template v-slot:item="{ item, headers }">
            <tr class="table-v-tr" style="cursor: default">
              <td v-for="col in headers" v-bind:key="col.key">
                {{ col.format ? col.format(item[col.value]) : item[col.value] }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>

      <span class="h5 m-3 d-block font-weight-bold">
         Cálculo Ano:
        {{ anoAnterior && anoAnterior[0] ? anoAnterior[0].ano : "" }}
      </span>

      <div class="teros-elevation rounded">
        <v-data-table
          class="mb-6"
          data-app
          :headers="headerStyle(colunasColaboradores)"
          :items="colaboradores.anoAnterior"
          :footer-props="{
            'items-per-page-options': [-1],
          }"
          hide-default-footer
        >
          <template v-slot:item="{ item, headers }">
            <tr class="table-v-tr" style="cursor: default">
              <td v-for="(col, idx) in headers" v-bind:key="idx" :class="{ 'font-weight-bold': col.value == 'media' }">
                <span v-if="!isNaN(col.value)">                  
                  {{
                    item[col.value] && item[col.value].ativo
                      ? item[col.value].ativo
                      : ""
                  }}
                </span>
                <span v-else>
                  {{ col.format ? col.format(item[col.value]) : item[col.value] }}
                </span>
              </td>
            </tr>
          </template>
          <template v-slot:[`body.append`]="append">
            <tr class="table-v-tr" style="cursor: default">
              <th v-for="col in append.headers" v-bind:key="col.key">
                <span v-if="col.value === 'nome'">TOTAL</span>
                <span v-else-if="col.value === 'media'">{{ totalPorCompetenciaAnoAtual[col.value] }}</span>
                <span v-else-if="!isNaN(col.value)">
                  {{
                    totalPorCompetenciaAnoAnterior[col.value] > 0
                      ? totalPorCompetenciaAnoAnterior[col.value]
                      : ""
                  }}
                </span>
                <span v-else></span>
              </th>
            </tr>
          </template>
        </v-data-table>
      </div>
      <span class="h5 m-3 d-block font-weight-bold">
        Calculo Ano:
        {{ anoAtual && anoAtual[0] ? anoAtual[0].ano : "" }}
      </span>
      <div class="teros-elevation rounded">
        <v-data-table
          class="mb-6"
          data-app
          :headers="headerStyle(colunasColaboradores)"
          :items="colaboradores.anoAtual || []"
          :footer-props="{
            'items-per-page-options': [-1],
          }"
          hide-default-footer
        >
          <template v-slot:item="{ item, headers }">
            <tr class="table-v-tr" style="cursor: default">
              <td v-for="(col, idx) in headers" v-bind:key="idx" :class="{ 'font-weight-bold': col.value == 'media' }">                
                <span v-if="!isNaN(col.value)">
                  {{
                    item[col.value] && item[col.value].ativo
                      ? item[col.value].ativo
                      : ""
                  }}
                </span>
                <span v-else>
                  {{ col.format ? col.format(item[col.value]) : item[col.value] }}
                </span>
              </td>
            </tr>
          </template>
          <template v-slot:[`body.append`]="append">
            <tr class="table-v-tr" style="cursor: default">
              <th v-for="col in append.headers" v-bind:key="col.key">
                <span v-if="col.value === 'nome'">TOTAL</span>
                <span v-else-if="col.value === 'media'">{{ totalPorCompetenciaAnoAtual[col.value] }}</span>
                <span v-else-if="!isNaN(col.value)">
                  {{
                    totalPorCompetenciaAnoAtual[col.value] > 0
                      ? totalPorCompetenciaAnoAtual[col.value]
                      : ""
                  }}
                </span>
                <span v-else></span>
              </th>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>

    <QueueDialog
      title="Relatório - Incremento pesquisador"
      :opened.sync="showDialog"
    ></QueueDialog>
  </div>
</template>

<script>
import { formatCPF } from "@/helpers/masks";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    QueueDialog: () => import("@/components/queue-dialog.vue"),
  },
  computed: {
    ...mapGetters(["clientId"]),
    // Usuários do cliente (Gerencial e Operacional) não veem CPF nem exportações
    isCliente() {
      return this.getClient().isClient;
    },
    colunasColaboradores() {
      return this.colunasDetalhado.colaboradores.filter(
        (coluna) => !this.isCliente || coluna.value !== "cpf"
      );
    },
    resource() {
      return this.apiResource(
        `/v1/rh/clientes/${this.clientId}/incremento-pesquisador`
      );
    },
    detalhes: function () {
      return this.relatorioIncremento.resumo.map((detalhe) => {
        detalhe["anoTitulo"] = `Ano Base ${detalhe.ano}`;
        return detalhe;
      });
    },
    anoAnterior: function () {
      const colaboradores = this.relatorioIncremento.colaboradores[this.anoBase - 1];
      if(colaboradores && colaboradores.length > 0) {
        return colaboradores;
      }
      return [ { ano: this.anoBase - 1 }];
    },
    totalAnoAnterior: function () {
      var total = this.relatorioIncremento.resumo.find(
        (d) => this.anoAnterior[0] && this.anoAnterior[0].ano == d.ano
      );
      return total ? total : {};
    },
    anoAtual: function () {
      const colaboradores = this.relatorioIncremento.colaboradores[this.anoBase];
      if(colaboradores && colaboradores.length > 0) {
        return colaboradores;
      }
      return [{ ano: this.anoBase }];
    },
    totalAnoAtual: function () {
      var total = this.relatorioIncremento.resumo.find(
        (d) => this.anoAtual[0] && this.anoAtual[0].ano == d.ano
      );
      return total ? total : {};
    },
    anosBase: function () {
      const anoAtual = new Date().getFullYear();
      const anoInicial = 2025;

      const primeiroAno = Math.max(anoInicial, anoAtual - 4);

      const anos = [];
      for (let ano = primeiroAno; ano <= anoAtual; ano++) {
        anos.push(ano);
      }

      return anos;
    },
    colaboradores() {
      let anoAnterior = this.relatorioIncremento.colaboradores[this.anoBase - 1];
      let anoAtual = this.relatorioIncremento.colaboradores[this.anoBase];

      if (anoAnterior) {
        anoAnterior = anoAnterior.map((colaborador) => {
          const meses = Object.values(colaborador.meses);
          return {
            ...colaborador,
            ...meses,
            media: {
              ativo: meses[11].ativo == 1 ? 1 : 0
            }
          };
        });
      }

      if (anoAtual) {
        anoAtual = anoAtual.map((colaborador) => {
          const meses = Object.values(colaborador.meses);
          return {
            ...colaborador,
            ...meses,
            media: {
              ativo: meses[11].ativo == 1 ? 1 : 0
            }
          };
        });
      }

      return {
        anoAnterior: anoAnterior,
        anoAtual: anoAtual,
      };
    },
    totalPorCompetenciaAnoAnterior() {
      const total = {};
      this.colaboradores?.anoAnterior?.forEach((colab) => {
        Object.keys(colab).forEach((key) => {
          if(key == 'media' && colab[key]?.ativo === 1) {
            total[key] = (total[key] || 0) + 1;
          }
          if (!isNaN(key) && colab[key]?.ativo === 1) {
            total[key] = (total[key] || 0) + 1;
          }
        });
      });

      return total;
    },
    totalPorCompetenciaAnoAtual() {
      const total = {};
      this.colaboradores?.anoAtual?.forEach((colab) => {
        Object.keys(colab).forEach((key) => {
          if(key == 'media' && colab[key]?.ativo === 1) {
            total[key] = (total[key] || 0) + 1;
          }
          if (!isNaN(key) && colab[key]?.ativo === 1) {
            total[key] = (total[key] || 0) + 1;
          }
        });
      });
      return total;
    },
  },
  created: function () {
    this.anoBase = new Date().getFullYear();
    this.doLoad();
  },
  methods: {
    doLoad: function () {
      this.resource
        .get({ query: `anoBase=${this.anoBase}` })
        .then((response) => {
          this.relatorioIncremento = response;
        });
    },
    headerStyle: function (headers) {
      return headers.map((h) => {
        h.class = `vuetify-table-header${
          this.getClient().isClient ? "-cli" : ""
        }`;
        return h;
      });
    },
    getDate: function (date) {
      if (!date) {
        return { ano: null, mes: null, dia: null };
      }
      var arr = date.split("-");
      return { ano: arr[0], mes: arr[1], dia: arr[2] };
    },
    doAsyncExport(tipo = 'incremento-pesquisadores') {
      const resource = this.apiResource(
        `v1/clientes/${this.clientId}/exportacao`
      );
      return resource.save(this.asynExportData(tipo)).then((result) => {
        try {
          if (result) {
            this.showDialog = true;
          }
        } catch (error) {
          console.log(error);
        }
      });
    },
    asynExportData(tipo) {
      return {
        tipoRelatorio: tipo,
        anoBase: this.anoBase,
      };
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("DD/MM/YYYY");
      }
    },
  },
  data: function () {
    return {
      relatorioIncremento: {
        colaboradores: {},
        resumo: [],
      },
      anoBase: 2020,
      colunas: {
        detalhes: [
          { text: "Cálculo do Incremento", value: "anoTitulo" },
          { text: "Quantidade pesquisadores", value: "total"},
          { text: "Acréscimo", value: "acrescimo" },
          { text: "Percentual de Utilização", value: "incentivo" },
          { text: "Mensagem", value: "comentario" },
        ],
        ano: [
          { text: "Nome Colaborador", value: "nome" },
          { text: "CPF", value: "cpf", format: formatCPF },
          {
            text: "Data Admissão em P&D",
            value: "admissao",
            format: (value) => this.formatDate(value),
          },
          {
            text: "Data Desligamento em P&D",
            value: "desligamento",
            format: (value) => this.formatDate(value),
          },
          { text: "Cálculo Ano", value: "calculoAno" },
          { text: "Percentual de Utilização", value: "incentivo" },
        ],
      },
      colunasDetalhado: {
        resumo: [
          { text: "", value: "ano" },
          { text: "Quantidade", value: "media" },
          { text: "Acrécimo", value: "acrescimo" },
        ],
        colaboradores: [
          { text: "Nome", value: "nome" },
          { text: "CPF", value: "cpf", format: formatCPF },
          {
            text: "Data Admissão",
            value: "admissao",
            format: (value) => this.formatDate(value),
          },
          {
            text: "Data Desligamento",
            value: "desligamento",
            format: (value) => this.formatDate(value),
          },
          { text: "Jan.", value: "0" },
          { text: "Fev.", value: "1" },
          { text: "Mar.", value: "2" },
          { text: "Abr.", value: "3" },
          { text: "Mai.", value: "4" },
          { text: "Jun.", value: "5" },
          { text: "Jul.", value: "6" },
          { text: "Ago.", value: "7" },
          { text: "Set.", value: "8" },
          { text: "Out.", value: "9" },
          { text: "Nov.", value: "10" },
          { text: "Dez.", value: "11" },
        ],
      },
      showDialog: false,
    };
  },
  watch: {
    clientId: function () {
      this.doLoad();
    },
  },
};
</script>
